/**
 * Operator Client
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const TimeSeriesType = {
    FixedTimeBased: 'FixedTimeBased',
    DurationBased: 'DurationBased'
} as const;
export type TimeSeriesType = typeof TimeSeriesType[keyof typeof TimeSeriesType];

